import { css } from '@emotion/react';
import { PaymentMethod } from '@frontend/api-payment-plans';
import { useFirstSelectedLocation } from '@frontend/payments-hooks';
import { theme } from '@frontend/theme';
import { useAlert } from '@frontend/design-system';
import { MultiProcessor } from '..';

/*
  Example Invoice 
  Location: Demo office 157
  {
    "data": {
      "id": "647e785c-9978-46b9-8876-4bd048ee05d7",
      "billedAmount": 3400,
      "hasAttachment": false,
      "isActive": true,
      "uniqueLink": "4q1q0tijiu",
      "status": "UNPAID",
      "billedAt": "2025-03-05T17:04:07.177119Z",
      "person": {
        "id": "4fd21651-771a-5ee2-9a00-0a541c7d5866",
        "pmid": "a235c4df-71ed-4469-b3ae-67056973e8d8",
        "name": "Crisstty Abot",
        "mobilePhone": "2342342342",
        "emailAddress": ""
      },
      "links": {
        "self": "https://api.weavedev.net/payments/requests/647e785c-9978-46b9-8876-4bd048ee05d7",
        "payment": "https://api.weavedev.net/payments/requests/4q1q0tijiu"
      },
      "locationId": "9f3c3252-a5d5-4f0a-bd44-1cc5076a2367",
      "locationName": "Tyler Campbell Demo",
      "paymentPlanId": "00000000-0000-0000-0000-000000000000",
      "providerName": "",
      "memo": "",
      "skipAttachmentAuth": true
    }
  }
 */

const styles = {
  exampleRow: css`
    text-align: center;
    padding: 16px;
    background: ${theme.colors.neutral20};
  `,
  spacer: css`
    margin-bottom: ${theme.spacing(2)};
  `,
};
export const ExampleCardOnFile = () => {
  const onCardSaved = (paymentMethod: PaymentMethod) => {
    console.log('master callback => card saved successfully', paymentMethod);
    alert.success('Card saved successfully!');
  };
  const onCancel = () => {
    console.log('master callback => card saving cancelled');
  };

  const alert = useAlert();

  const onError = (message: string) => {
    console.log('master callback => error', message);
    alert.error(message);
  };

  const { locationId } = useFirstSelectedLocation();

  return (
    <>
      <div css={styles.exampleRow}>before all</div>
      <MultiProcessor.CardOnFile
        locationId={locationId || ''}
        personId='4fd21651-771a-5ee2-9a00-0a541c7d5866'
        onCardSaved={onCardSaved}
        onCancel={onCancel}
        onError={onError}
      >
        <MultiProcessor.CardOnFile.Container>
          <MultiProcessor.CardOnFile.Form />

          <div css={[styles.exampleRow, styles.spacer]}>custom spacer</div>

          <MultiProcessor.CardOnFile.Actions />
        </MultiProcessor.CardOnFile.Container>
      </MultiProcessor.CardOnFile>

      <div css={styles.exampleRow}>after all</div>
    </>
  );
};
